/**
 * Portal screenshot payloads from Socket.IO / JSON sometimes include a full data URL;
 * the <img> src already adds data:image/png;base64, — strip to raw base64 only.
 */
export function normalizePortalScreenshotB64(raw) {
  let s = String(raw ?? '').trim();
  const m = s.match(/^data:image\/(?:png|jpeg|webp);base64,([\s\S]+)$/i);
  if (m) s = m[1];
  return s.replace(/\s/g, '');
}

/** Compare session ids from ?room=demo-<uuid> vs backend payload (case-insensitive). */
export function sameDemoSessionId(roomSessionId, eventSessionId) {
  const norm = (v) => String(v || '').trim().toLowerCase().replace(/^demo-/, '');
  const a = norm(roomSessionId);
  const b = norm(eventSessionId);
  if (!b) return true;
  // No room id parsed yet — don’t drop events (would leave portal blank forever).
  if (!a) return true;
  return a === b;
}
